import React from 'react';
import { CreateViewDialog } from '../CreateViewDialog';
import { RenameViewDialog } from '../RenameViewDialog';
import { useUserViews } from './useUserViews';
import { UserViewsSelectedView } from './UserViewsSelectedView';
import { UserViewsToolbar } from './UserViewsToolbar';
import { findViewById } from './userViewsUtils';

export const UserViews: React.FC = () => {
  const {
    translate,
    views,
    selectedView,
    isLoading,
    showCreateDialog,
    showRenameDialog,
    DialogComponent,
    buttonStates,
    handleViewChange,
    handleCreatePrivateView,
    handleDialogClose,
    handleRenameView,
    handleRenameDialogClose,
    handleUpdateView,
    handleRenameViewSubmit,
    handleDeleteView,
    handleCreateNewView
  } = useUserViews();

  if (isLoading) {
    return <div>{translate('custom.settings.views.loading')}</div>;
  }

  return (
    <div className="viewsManagement">
      <UserViewsToolbar
        views={views}
        selectedView={selectedView}
        translate={translate}
        isPrivateViewLimitReached={buttonStates.isPrivateViewLimitReached}
        isRenameDisabled={buttonStates.isRenameDisabled}
        isDeleteDisabled={buttonStates.isDeleteDisabled}
        isSaveDisabled={buttonStates.isSaveDisabled}
        hasIncompleteData={buttonStates.hasIncompleteData}
        isGlobalFiltersLimitExceeded={buttonStates.isGlobalFiltersLimitExceeded}
        onViewChange={handleViewChange}
        onCreatePrivateView={handleCreatePrivateView}
        onRenameView={handleRenameView}
        onDeleteView={handleDeleteView}
        onUpdateView={handleUpdateView}
      />
      <div className="viewsManagementContent">
        <UserViewsSelectedView views={views} selectedView={selectedView} />
      </div>

      <CreateViewDialog open={showCreateDialog} onClose={handleDialogClose} onCreateView={handleCreateNewView} />

      {selectedView != null && (
        <RenameViewDialog
          open={showRenameDialog}
          onClose={handleRenameDialogClose}
          onRenameView={handleRenameViewSubmit}
          currentViewId={selectedView}
          currentViewName={findViewById(views, selectedView)?.name ?? ''}
        />
      )}

      {DialogComponent}
    </div>
  );
};
